import { render, staticRenderFns } from "./loaninfosetting.vue?vue&type=template&id=18c2e60b&scoped=true&"
import script from "./loaninfosetting.vue?vue&type=script&lang=js&"
export * from "./loaninfosetting.vue?vue&type=script&lang=js&"
import style0 from "./loaninfosetting.vue?vue&type=style&index=0&id=18c2e60b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2e60b",
  null
  
)

export default component.exports